import type {
    CharmSuggestionsViewState,
    CharmSuggestionsItem,
} from 'owa-calendar-charm-suggestions-data';
import { setCharmSuggestionsHighlightedIndex } from 'owa-calendar-compose-form-actions';
import type { KeyboardEvent } from 'react';
import { KeyCodes } from '@fluentui/react/lib';

export default function subjectOnKeyDown(
    target: KeyboardEvent<unknown>,
    onDismiss: (formId: string) => { formId: string },
    onSelectCharm: (item: CharmSuggestionsItem) => void,
    state: CharmSuggestionsViewState,
    formId: string
) {
    if (state.shouldShowSuggestions) {
        switch (target.keyCode) {
            case KeyCodes.down:
                target.preventDefault();
                // Move down through the charm suggestions
                setCharmSuggestionsHighlightedIndex(true, formId);
                return;
            case KeyCodes.up:
                target.preventDefault();
                // Move up through the charm suggestions
                setCharmSuggestionsHighlightedIndex(false, formId);
                return;
            case KeyCodes.tab:
                selectCharm(onSelectCharm, state);
                return;
            case KeyCodes.enter:
                target.preventDefault();
                selectCharm(onSelectCharm, state);
                return;
            case KeyCodes.escape:
                // Hide the charm suggestions
                target.stopPropagation();
                onDismiss(formId);
                return;
        }
    }
}

function selectCharm(
    onSelectCharm: (item: CharmSuggestionsItem) => void,
    state: CharmSuggestionsViewState
) {
    let selectedCharm: CharmSuggestionsItem = state.suggestions[state.highlightedIndex];
    // Select the option from the charm suggests and lose focus
    onSelectCharm(selectedCharm);
}
